// Global toast notification bus. Works from React components and from plain JS classes
// (EditorJS tools) alike, since it's a plain singleton, not a React context.

let toasts = [];
let listeners = [];
let idCounter = 0;

const DURATION_MS = 5000;

const notify = () => {
    listeners.forEach((listener) => listener(toasts));
};

const dismiss = (id) => {
    toasts = toasts.filter((item) => item.id !== id);
    notify();
};

const push = (type, message) => {
    if (!message) return null;
    const id = ++idCounter;
    toasts = [...toasts, { id, type, message }];
    notify();
    setTimeout(() => dismiss(id), DURATION_MS);
    return id;
};

const toast = {
    error: (message) => push('error', message),
    success: (message) => push('success', message),
    warning: (message) => push('warning', message),
    info: (message) => push('info', message),
    dismiss,
    subscribe: (listener) => {
        listeners.push(listener);
        listener(toasts);
        return () => {
            listeners = listeners.filter((item) => item !== listener);
        };
    },
};

export default toast;
